module.exports = __webpack_public_path__ + "static/img/ic_kfz.226ffd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_kfz.png
// module id = FBGH
// module chunks = 19